import { useTranslation } from "react-i18next";
import { Settings, Users, Target, Zap, Shield } from "lucide-react";

const features = [
  { icon: Settings, key: "endtoend", color: "text-textBlue" },
  { icon: Users, key: "expertise", color: "text-secondaryOrange" },
  { icon: Target, key: "customer", color: "text-primaryBlue" },
  { icon: Zap, key: "innovation", color: "text-bgYellow" },
  { icon: Shield, key: "security", color: "text-textBlueDark" },
];

const WhyChooseUs = () => {
  const { t } = useTranslation();

  return (
    <section className="py-24 tablet:py-20 px-6 mobile:px-4 bg-blueLight scroll-mt-24">
      <div className="container-page">
        <div className="mb-14 max-w-3xl">
          <span className="kicker mb-4 !text-textBlueDark">{t("why.label")}</span>
          <h2 className="text-4xl tablet:text-3xl mobile:text-2xl font-semibold tracking-[-0.02em] text-textBlueDark">
            {t("why.title")}
          </h2>
        </div>

        <div className="grid grid-cols-2 tablet:grid-cols-1 gap-6">
          {features.map((feature) => {
            const Icon = feature.icon;
            return (
              <div
                key={feature.key}
                className={`group flex items-start gap-5 rounded-xl border border-white bg-white/70 p-6 transition-[background-color,box-shadow,transform] duration-300 hover:bg-white hover:shadow-lg hover:-translate-y-1 ${
                  feature.key === "security" ? "tablet:col-span-2 mobile:col-span-1" : ""
                }`}
              >
                <span className="w-12 h-12 rounded-xl bg-blueLight flex items-center justify-center shrink-0 transition-transform duration-300 group-hover:scale-110">
                  <Icon className={`w-6 h-6 ${feature.color}`} aria-hidden="true" />
                </span>
                <div>
                  <h3 className="text-lg font-semibold text-textBlueDark mb-2 tracking-[-0.01em] transition-colors duration-300 group-hover:text-textBlue">
                    {t(`why.items.${feature.key}.title`)}
                  </h3>
                  <p className="text-sm text-gray-600 leading-relaxed max-w-[52ch]">
                    {t(`why.items.${feature.key}.description`)}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
